import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      player: null,
      isAuthenticated: false,

      login: (token, user, player) => set({ token, user, player, isAuthenticated: true }),

      logout: () => set({ token: null, user: null, player: null, isAuthenticated: false }),

      refreshSession: (user, player) => set({ user, player, isAuthenticated: true }),

      updatePlayer: (partial) => set((s) => ({ player: { ...s.player, ...partial } })),

      updateCoins: (coins) => set((s) => ({ player: s.player ? { ...s.player, coins } : s.player })),

      updateXP: (xp, level) => set((s) => ({
        player: s.player ? { ...s.player, xp, level: level || s.player.level } : s.player,
      })),
    }),
    { name: 'hakken-auth', partialize: (s) => ({ token: s.token, user: s.user, player: s.player, isAuthenticated: s.isAuthenticated }) }
  )
);

export default useAuthStore;
